import React, { Component } from 'react';
import VirtualizedTable from "../../../components/common/virtualized-table";
import {Icon, Menu, MenuItem, Popover, PopoverInteractionKind, Position} from "@blueprintjs/core";
import Modal from '@atlaskit/modal-dialog';
import { connect } from 'react-redux';
import {Map, List} from "immutable";

import RegisterStockDialog from '../../../components/dialogs/RegisterStockDialog'
import AdjustStockDialog from "../../../components/dialogs/AdjustStockDialog";

import {getStockList} from "../../../actions/stock";


class WarehouseStock extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canSubmit: false,
            onCreateClick: false,
            modalIsOpen: false,
            modalType: null,
            stock: Map({}),
            stockListFilter: ''
        }
    }

    componentDidMount() {
        this.props.getStockList({
            filters: {
                warehouse: this.props.warehouse.get('_id')
            },
            projection: 'product real_amount available_amount total_amount security_stock',
            populateRefs: [{
                field: 'product',
                projection: 'name'
            }]
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.state.canSubmit !== nextState.canSubmit ||
            this.state.modalIsOpen !== nextState.modalIsOpen ||
            this.props !== nextProps ||
            this.state.onCreateClick !== nextState.onCreateClick ||
            this.state.stockListFilter !== nextState.stockListFilter
        )
    }

    onCanSubmit = (canSubmit) => {
        this.setState({
            canSubmit
        });
    };

    // Modal Handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {

        this.setState({
            modalType: null,
            modalIsOpen: false,
            canSubmit: false,
            onCreateClick: false
        })
    };

    render() {
        const { canSubmit, modalIsOpen, modalType, stock } = this.state;
        const { warehouse, stockList } = this.props;

        let tableData = stockList;
        let statsZone = (
            <div className="row stats-zone" style={{ margin: '10px 0' }} >
                <div className="col-auto">
                    <span className="label label-primary"><strong>{stockList.size}</strong></span>
                    <span className="handPointer" onClick={ () => this.setState({ stockListFilter: '' }) } >
                        <strong>Productos con stock</strong>
                    </span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">
                        { stockList.count( stock => stock.get('security_stock') <= 0) }
                    </span>
                    <span className="handPointer" onClick={ () => this.setState({ stockListFilter: 'security_stock' }) } >
                        Productos sin stock de seguridad
                    </span>
                </div>
                <div className="col-auto ml-auto">
                    <button className="btn btn-primary" onClick={ () => this.openModal('registerStockDialog') } >
                        <Icon icon="insert"/>Registrar stock
                    </button>
                </div>
            </div>
        );

        if (this.state.stockListFilter === 'security_stock') {
            statsZone = (
                <div className="row stats-zone" style={{ margin: '10px 0' }} >
                    <div className="col-auto">
                        <span className="label label-primary">{stockList.size}</span>
                        <span className="handPointer" onClick={ () => this.setState({ stockListFilter: '' }) } >
                            Productos con stock
                        </span>
                    </div>
                    <div className="col-auto">
                        <span className="label label-danger">
                            <strong>{ stockList.count( stock => stock.get('security_stock') <= 0) }</strong>
                        </span>
                        <span className="handPointer" onClick={ () => this.setState({ stockListFilter: 'security_stock' }) } >
                            <strong>Productos sin stock de seguridad</strong>
                        </span>
                    </div>
                    <div className="col-auto ml-auto">
                        <button className="btn btn-primary" onClick={ () => this.openModal('registerStockDialog') } >
                            <Icon icon="insert"/>Registrar stock
                        </button>
                    </div>
                </div>
            );
            tableData = stockList.filter(stock => stock.get('security_stock') <= 0);
        }

        let tableSettings = {
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            name: {
                title: 'Producto',
                columnType: 'text',
                dataField: 'product',
                width: 200,
                style: {},
                sortable: true,
                filterable: true
            },
            real_amount: {
                title: "Stock real",
                columnType: 'text',
                dataField: 'real_amount',
                width: 100,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: false
            },
            available_amount: {
                title: "Stock disponible",
                columnType: 'text',
                dataField: 'available_amount',
                width: 100,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: false
            },
            total_amount: {
                title: "Stock total",
                columnType: 'text',
                dataField: 'total_amount',
                width: 100,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: false
            },
            security_stock: {
                title: "Stock de seguridad",
                columnType: 'text',
                dataField: 'security_stock',
                width: 100,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: false
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (stockId) => {
                    const index = stockList.findIndex(stock => stock.get('_id') === stockId);
                    const stock = stockList.get(index);
                    const popoverContent = (
                        <Menu>
                            <MenuItem icon="eye-open" text="Ajustar stock" onClick={ () => {
                                this.setState({ stock }, () => this.openModal('adjustStockDialog'))
                            }} />
                        </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        // Modal Area
        let modal = null;

        if (modalIsOpen) {
            switch (modalType) {
                case 'registerStockDialog':
                    modal = {
                        width: 'large',
                        title: 'Registrar Stock',
                        body: (
                            <RegisterStockDialog
                                warehouseId={warehouse.get('_id')}
                                warehouseName={warehouse.get('name')}
                                onCanSubmit={this.onCanSubmit}
                                onCreateClick={this.state.onCreateClick}
                                onCloseModal={this.closeModal}
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="accept"
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!canSubmit}
                                    onClick={ () => this.setState({ onCreateClick: true }) }
                                >
                                    {'Crear'}
                                </button>
                            </div>
                        )
                    };
                    break;
                case 'adjustStockDialog':
                    modal = {
                        width: 'medium',
                        title: 'Ajustar Stock',
                        body: (
                            <AdjustStockDialog
                                stock={stock}
                                warehouseName={warehouse.get('name')}
                                onCanSubmit={this.onCanSubmit}
                                onCreateClick={this.state.onCreateClick}
                                onCloseModal={this.closeModal}
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="accept"
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!canSubmit}
                                    onClick={ () => this.setState({ onCreateClick: true }) }
                                >
                                    {'Guardar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (
            <div className="panel-body">
                { statsZone }
                <VirtualizedTable
                    tableSettings={tableSettings}
                    tableColumns={tableColumns}
                    tableData={tableData}
                />
                { modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const stockReducer = state.stock;

    // Stock
    const stockList = stockReducer.get('payload') || List([]);

    return {
        stockList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getStockList: (query) => dispatch(getStockList(query))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseStock);


// WEBPACK FOOTER //
// ./src/containers/configuration/warehouses/WarehouseStock.js